import(/* webpackMode: "eager", webpackExports: ["UIProviders"] */ "/app/src/_components/UIProviders.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-pdf/dist/esm/Page/TextLayer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-pdf/dist/esm/Page/AnnotationLayer.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
